// 20px ring inside a 24px hit box, solid orange 14px dot when selected.
const OptionRadio = ({ selected }: { selected: boolean }) => (
  <span className="flex size-[24px] shrink-0 items-center justify-center">
    <span
      className={`flex size-[20px] items-center justify-center rounded-full border border-solid bg-white ${
        selected ? "border-[#f08e00]" : "border-[#b5bdcc]"
      }`}
    >
      {selected && <span className="size-[14px] rounded-full bg-[#f08e00]" />}
    </span>
  </span>
);

export default OptionRadio;
